import { render } from "./UnassignedClientUsersTable.vue?vue&type=template&id=e431fac0&ts=true"
import script from "./UnassignedClientUsersTable.vue?vue&type=script&lang=ts"
export * from "./UnassignedClientUsersTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable});
